/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { TaskAnnotationStatus } from './taskAnnotationStatus';


export interface CreateSharingTaskDto { 
    _id?: string;
    expiryDate: string;
    /**
     * List of emails to share with, can be an empty array
     */
    userEmails: Array<string>;
    description?: string;
    noDownload?: boolean;
    publicLink?: boolean;
    taskId: string;
    taskName: string;
    annotationStatus: Array<TaskAnnotationStatus>;
}

